module.exports = __webpack_public_path__ + "img/timetable.1bd108f5.png";